import React from "react";

const OrderInformation = ({ dataDetail, distributionStatus }) => {
  const paymentMethod = [
    { paymentMethod: "credit", text: "クレジットカード" },
    { paymentMethod: "invoice", text: "インボイス" },
    { paymentMethod: "bank_transfer", text: "銀行振込" },
    { paymentMethod: "cvs", text: "コンビニ決済" },
    { paymentMethod: "pay_easy", text: "ペイイージー" },
  ];

  const cvsOptions = [
    { cvsCode: "00007", cvsName: "セブンイレブン" },
    { cvsCode: "00001", cvsName: "ローソン" },
    { cvsCode: "00002", cvsName: "ファミリーマート" },
    { cvsCode: "00005", cvsName: "ミニストップ" },
    { cvsCode: "00008", cvsName: "セイコーマート" },
    { cvsCode: "00006", cvsName: "デイリーヤマザキ" },
  ];

  return (
    <div className="w-full w-12/12 flex flex-col sm:flex-row gap-0 sm:gap-2">
      {/* Left */}
      <div className="order__detail w-12/12 sm:w-6/12 flex flex-col">
        <table className="w-[100%] text-left text-sm md:text-base">
          <tbody className="">
            <tr>
              <td
                colSpan="2"
                className="bg-primary bg-opacity-50 font-bold border-[1px] border-black px-2 py-[4px]"
              >
                お客様情報
              </td>
            </tr>
            <tr>
              <td className="font-bold">お客様会社名</td>
              <td>{dataDetail?.extra?.company?.name}</td>
            </tr>
            <tr>
              <td className="font-bold">お客様ID</td>
              <td>{dataDetail?.user_id}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* End Left */}

      {/* Right */}
      <div className="order__detail w-12/12 sm:w-6/12 mt-8 sm:mt-0">
        <table className="w-[100%] text-left text-sm md:text-base">
          <tbody className="">
            <tr>
              <td
                colSpan="2"
                className="bg-primary bg-opacity-50 font-bold border-[1px] border-black px-2 py-[4px]"
              >
                注文情報
              </td>
            </tr>
            <tr>
              <td className="font-bold">注文日時</td>
              <td>{dataDetail?.created_at}</td>
            </tr>
            <tr>
              <td className="font-bold">折込日時</td>
              <td>{dataDetail?.insertion_date}</td>
            </tr>
            <tr>
              <td className="font-bold">部数</td>
              <td>{dataDetail?.estimation?.quantity}</td>
            </tr>
            <tr>
              <td className="font-bold">単価</td>
              <td>{dataDetail?.estimation?.unit_price?.toFixed(2)}</td>
            </tr>
            <tr>
              <td className="font-bold">注文ステイタス</td>
              <td>
                {distributionStatus?.map(
                  (status, idx) => idx === dataDetail?.status && status
                )}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
              支払い方法
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail?.extra?.payment?.method !== "invoice" &&
                  paymentMethod.map(
                    (pm, i) =>
                      pm.paymentMethod ===
                        dataDetail?.extra?.payment?.method && (
                        <span key={i} className="mr-2">
                          {pm.text}
                        </span>
                      )
                  )}
                {dataDetail?.extra?.payment?.method === "cvs"
                  ? cvsOptions.map(
                      (co, i) =>
                        co.cvsCode ===
                          dataDetail?.extra?.payment?.convenience_code && (
                          <span key={i} className="">
                            {"  "}({co.cvsName})
                          </span>
                        )
                    )
                  : null}
              </td>
            </tr>
            <tr>
              <td className="w-[50%] border-[1px] border-black px-2 py-[4px] font-bold">
              支払状態
              </td>
              <td className="w-[50%] border-[1px] border-black px-2">
                {dataDetail?.extra?.payment?.paid === 1
                  ? "支払済み"
                  : "未払い"}
              </td>
            </tr>
            <tr>
              <td className="font-bold">支払日</td>
              <td>
                {(dataDetail?.extra?.payment?.paid_date === null ||
                  dataDetail?.extra?.payment?.paid_date === "") &&
                dataDetail?.extra?.payment?.method !== "invoice"
                  ? dataDetail?.extra?.payment?.paid_date
                  : "未払い"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* End Right */}
    </div>
  );
};

export default OrderInformation;
